import { ReplaySubject, Subject } from 'rxjs';
import { OpenIdProfileInterface } from '../interface/open-id-profile.interface';
import { OpenIdService } from '../service/open-id.service';
import { Constructor } from '../type/constructor';

export function OpenIdProfileMixin<TBase extends Constructor>(Base: TBase) {
    return class OpenIdProfile extends Base {
        public openIdProfile?: OpenIdProfileInterface;
        public $openIdReady = new ReplaySubject<boolean>();
        protected openIdService: OpenIdService;
        constructor(...args: any[]) {
            super(...args);
            this.openIdService = args[0];
            this.openIdService.$userProfile.subscribe(
                (openIdProfile: OpenIdProfileInterface) => {
                    if (!openIdProfile) return;
                    this.openIdProfile = openIdProfile;
                    this.$openIdReady.next(true);
                }
            );
        }
    };
}
